import BrandHeader from './BrandHeader';

export default BrandHeader;
